import * as fromUserRole from './actions';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IUserRole } from '../IUserRole';

export interface UserRoleState {
    userRoles: Array<IUserRole>;
}

export const initialState: UserRoleState = {
    userRoles: []
};

export function reducer(
    state: UserRoleState = initialState,
    action: fromUserRole.UserRoleActionsUnion
): UserRoleState {
    switch (action.type) {
        case fromUserRole.UserRoleActionTypes.SetUserRole:
            return {
                ...state,
                userRoles: [...action.payload]
            };
        case fromUserRole.UserRoleActionTypes.Reset:
            return initialState;
        default:
            return state;
    }
}

const userRoleState = createFeatureSelector<UserRoleState>('user_role');

export const getUserRoles = createSelector(userRoleState, x => x.userRoles);
